import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { redirectToAllianzSchema } from './types'

export const redirectToAllianz = () => {
  return {
    schema: redirectToAllianzSchema,
    stepContent: [
      {
        type: 'image',
        src: 'https://cdn.sanity.io/images/p4gom3ch/production/c7b392a7b8c8ea1331463ee5aa67b350cc66125c-981x684.jpg',
        useURI: true,
        aspectRatio: 1.5,
        contentFit: 'contain',
        width: '100%',
        height: 228,
      },
      {
        type: 'spacer',
        size: 'xxsmall',
      },
      {
        type: 'title',
        size: 'h3',
        fontType: 'primary',
        align: 'center',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.title',
        },
      },
      {
        type: 'text',
        align: 'center',
        style: 'body1',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.subtitle',
        },
      },
      {
        type: 'spacer',
        size: 'xxsmall',
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            size: 'h5',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.info.title',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.info.text',
            },
          },
        ],
      },
    ],
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'terminateConsultationRequest',
        options: {
          reason: 'redirected',
        },
        inputs: ['redirected'],
        outputs: [],
      },
    },
    subFlow: SubFlow.Dental,
    footer: {
      customButtons: [
        {
          buttonLabel: {
            type: 'translatableText',
            translationKey: 'sharedFlows_dental:steps.dental_redirect_to_allianz.buttonLabel',
          },
          buttonId: 'redirect_to_allianz',
          actionConfig: {
            type: 'dispatchedHook',
            callbackConfig: {
              name: 'handleRedirectToAllianzSite',
              options: {
                redirectURL:
                  'https://www.allianz.de/angebot/kooperation/gesundheit/zahnzusatzversicherung/rechner/#getsafe_zahn',
              },
              inputs: [],
              outputs: [],
            },
          },
        },
        {
          buttonLabel: {
            type: 'translatableText',
            translationKey: 'sharedFlows_dental:steps.dental_close.buttonLabel',
          },
          buttonId: 'dental_insurance_close',
          buttonType: 'text',
          actionConfig: {
            type: 'dispatchedHook',
            callbackConfig: {
              name: 'dentalRedirectClose',
              inputs: [],
              outputs: [],
            },
          },
        },
      ],

      hideBackButton: true,
    },
  } as const satisfies AnyStepConfiguration
}
